import { render, staticRenderFns } from "./Certificate.html?vue&type=template&id=0174be00&scoped=true&external"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
import style0 from "./Certificate.scss?vue&type=style&index=0&id=0174be00&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0174be00",
  null
  
)

export default component.exports